import * as React from 'react';

import Icon from 'components/Icon';
import TooltipTrigger from 'components/TooltipTrigger';
import RosterConstants from 'constants/RosterConstants';
import Group from 'entities/Group';
import GroupAvatarWithText from 'groups/components/GroupAvatarWithText';

// @ts-ignore
import { GroupProfileType } from 'groups/components/GroupProfile';

type Props = {
  group: GroupProfileType;
};

export default function GroupProfileHeader({ group, ...others }: Props) {
  const { hasRosterSource } = group;

  const groupEntity = Group.fromJSON(group) as Group;

  return (
    <GroupAvatarWithText
      {...others}
      avatarSize="large"
      icon={
        <TooltipTrigger
          placement="top"
          tooltip={
            hasRosterSource ? RosterConstants.rosteredLabel : RosterConstants.notRosteredLabel
          }>
          <span>
            <Icon
              color={
                hasRosterSource ? RosterConstants.rosteredColor : RosterConstants.notRosteredColor
              }
              name={
                hasRosterSource ? RosterConstants.rosteredIcon : RosterConstants.notRosteredIcon
              }
              size="xlarge"
            />
          </span>
        </TooltipTrigger>
      }
      group={groupEntity}
      level="primary"
    />
  );
}
